import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { extend } from '@thd-nucleus/data-sources';
import { OnlineDoor } from './online-door/OnlineDoor';
import styles from './virtual-consulting.module.scss';

let cx = classNames.bind(styles);

export const VirtualConsulting = ({ itemId }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('virtual-consulting.ready'); }, []);

  if (!itemId) return null;

  return (
    <div className={cx('virtual-consulting')}>
      <OnlineDoor itemId={itemId} />
    </div>
  );
};

VirtualConsulting.displayName = 'VirtualConsulting';

VirtualConsulting.propTypes = {
  itemId: string.isRequired
};

VirtualConsulting.dataModel = extend(OnlineDoor);